import { formatDateRu, toDateInputValue } from "../../../utils/appointmentLabels";

export function adminGreeting() {
  const h = new Date().getHours();
  if (h < 12) return "Доброе утро";
  if (h < 18) return "Добрый день";
  return "Добрый вечер";
}

/** Имя для приветствия: при «Фамилия Имя …» — второе слово. */
export function adminFirstName(fullName) {
  const parts = String(fullName || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) return parts[1];
  return parts[0] || "";
}

export function adminTodayLabel() {
  const today = toDateInputValue();
  return formatDateRu(`${today}T12:00:00`, {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
}
